// "use client";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { loginUser, clearError } from "../../redux/slice";
// import { Shield, Eye, EyeOff, Loader2, Mail, Lock } from "lucide-react";
// import logo from "../../assets/avanaval1.png";
// import { Alert, AlertDescription } from "../ui/alert";
// import { Button } from "../ui/button";

// export function AdminLogin() {
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [showPassword, setShowPassword] = useState(false);
//   const [localError, setLocalError] = useState("");

//   const dispatch = useDispatch();
//   const { isAuthenticated, loading, error } = useSelector((state) => state.auth);

//   useEffect(() => {
//     if (error || localError) {
//       if (formData.email || formData.password) {
//         setLocalError("");
//         dispatch(clearError());
//       }
//     }
//   }, [formData.email, formData.password, dispatch]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const validateForm = () => {
//     if (!formData.email.trim()) {
//       setLocalError("Email is required");
//       return false;
//     }
//     if (!formData.password.trim()) {
//       setLocalError("Password is required");
//       return false;
//     }
//     if (!formData.email.includes("@")) {
//       setLocalError("Please enter a valid email address");
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLocalError("");
//     dispatch(clearError());
//     if (!validateForm()) return;
//     try {
//       await dispatch(loginUser(formData));
//     } catch (err) {
//       setLocalError("An unexpected error occurred");
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-orange-50 to-orange-100 px-4 py-8">
//       {/* Centered Login Box with proper gap */}
//       <div className="w-full max-w-4xl bg-white/90 backdrop-blur-xl border border-orange-100 shadow-2xl rounded-3xl overflow-hidden grid grid-cols-1 md:grid-cols-2 animate-fadeInUp mx-4">

//         {/* Left side – Branding */}
//         <div className="bg-gradient-to-br from-orange-500 to-orange-400 flex flex-col items-center justify-center p-8 md:p-10 text-center text-white animate-slideIn">
//           <img
//             src={logo}
//             alt="Logo"
//             className="w-32 h-32 md:w-40 md:h-40 object-contain transition-transform duration-300 hover:scale-105 mx-auto"
//           />
//           <h2 className="text-2xl md:text-3xl font-bold mt-6 drop-shadow-md">Avan Aval</h2>
//           <p className="mt-3 text-orange-50 text-base md:text-lg">
//             Admin Access Portal
//           </p>
//         </div>

//         {/* Right side – Login Form */}
//         <div className="flex flex-col justify-center p-6 md:p-8 lg:p-10 bg-white">
//           <div className="max-w-sm w-full mx-auto">
//             <h2 className="text-2xl md:text-3xl font-extrabold text-black text-center mb-2">
//               Sign In
//             </h2>
//             <p className="text-gray-500 text-center mb-6">
//               Use your admin credentials to continue
//             </p>

//             <form onSubmit={handleSubmit} className="space-y-5">
//               {(error || localError) && (
//                 <Alert variant="destructive" className="mb-2">
//                   <AlertDescription className="text-red-600 text-center font-medium">
//                     {error || localError}
//                   </AlertDescription>
//                 </Alert>
//               )}

//               {isAuthenticated && (
//                 <Alert className="bg-green-50 border-green-200 mb-2">
//                   <AlertDescription className="text-green-700 text-center">
//                     Login successful! Redirecting...
//                   </AlertDescription>
//                 </Alert>
//               )}

//               {/* Email Field - Reduced size */}
//               <div className="space-y-2">
//                 <label className="block text-sm font-semibold text-gray-700">
//                   Email 
//                 </label>
//                 <div className="relative">
//                   <div className="absolute left-3 top-1/2 transform -translate-y-1/2 flex items-center pointer-events-none">
//                     <Mail className="h-4 w-4 text-orange-400" />
//                   </div>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="admin@example.com"
//                     className="w-full rounded-lg border border-gray-300 bg-white py-3 pl-10 pr-4 text-gray-800 text-base focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-400 transition-all placeholder:text-gray-400 shadow-sm h-12"
//                     disabled={loading}
//                   />
//                 </div>
//               </div>

//               {/* Password Field - Moved down with additional margin */}
//               <div className="space-y-2 mt-4">
//                 <label className="block text-sm font-semibold text-gray-700">
//                   Password
//                 </label>
//                 <div className="relative">
//                   <div className="absolute left-3 top-1/2 transform -translate-y-1/2 flex items-center pointer-events-none">
//                     <Lock className="h-4 w-4 text-orange-400" />
//                   </div>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     placeholder="Enter your password"
//                     className="w-full rounded-lg border border-gray-300 bg-white py-3 pl-10 pr-12 text-gray-800 text-base focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-400 transition-all placeholder:text-gray-400 shadow-sm h-12"
//                     disabled={loading}
//                   />
//                   {/* <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center text-gray-400 hover:text-orange-500 transition-colors bg-transparent border-none outline-none"
//                     disabled={loading}
//                   >
//                     {showPassword ? (
//                       <EyeOff className="h-4 w-4" />
//                     ) : (
//                       <Eye className="h-4 w-4" />
//                     )}
//                   </button> */}
//                 </div>
//               </div>

//               {/* Submit Button - Reduced size */}
//               <Button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full py-3 font-semibold text-base rounded-lg shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed mt-6 border border-transparent hover:border-orange-800 h-12"
//                 style={{
//                   backgroundColor: '#f54a00',
//                   color: 'white'
//                 }}
//               >
//                 {loading ? (
//                   <span className="flex items-center justify-center text-white">
//                     <Loader2 className="w-5 h-5 animate-spin mr-2" />
//                     Signing In...
//                   </span>
//                 ) : (
//                   <span className="text-white">Sign In</span>
//                 )}
//               </Button>
//             </form>

//             {/* Footer */}
//             {/* <div className="text-center text-xs text-gray-400 mt-8 pt-6 border-t border-gray-100">
//               <div className="flex items-center justify-center">
//                 <Shield className="w-3 h-3 mr-1.5 text-orange-400" />
//                 <span>SoulMate Tamil Administration</span>
//               </div>
//             </div> */}
//           </div>
//         </div>
//       </div>

//       {/* Animations */}
//       <style>{`
//         @keyframes slideIn {
//           from { transform: translateX(-60px); opacity: 0; }
//           to { transform: translateX(0); opacity: 1; }
//         }
//         @keyframes fadeInUp {
//           from { transform: translateY(40px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }
//         .animate-slideIn { animation: slideIn 0.8s ease-out; }
//         .animate-fadeInUp { animation: fadeInUp 0.8s ease-out; }
//       `}</style>
//     </div>
//   );
// }


"use client";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, clearError } from "../../redux/slice";
import { Shield, Eye, EyeOff, Loader2, Mail, Lock } from "lucide-react";
import logo from "../../assets/aishwarya-faicon.png";
import { Alert, AlertDescription } from "../ui/alert";
import { Button } from "../ui/button";
import '../../styles/login.css'
import { ShieldAlert } from "lucide-react";
export function AdminLogin() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");

  const dispatch = useDispatch();
  const { isAuthenticated, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    if (error || localError) {
      if (formData.email || formData.password) {
        setLocalError("");
        dispatch(clearError());
      }
    }
  }, [formData.email, formData.password, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.email.trim()) {
      setLocalError("Email is required");
      return false;
    }
    if (!formData.password.trim()) {
      setLocalError("Password is required");
      return false;
    }
    if (!formData.email.includes("@")) {
      setLocalError("Please enter a valid email address");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError("");
    dispatch(clearError());
    if (!validateForm()) return;
    try {
      await dispatch(loginUser(formData));
    } catch (err) {
      setLocalError("An unexpected error occurred");
    }
  };

  return (
    <div className="av-admin-login-wrapper">
      <div className="av-admin-login-box">
        {/* Left side - Branding */}
        <div className="av-admin-brand-panel">
          <img
            src={logo}
            alt="Logo"
            className="av-admin-logo"
          />
        </div>

        {/* Right side - Login Form */}
        <div className="av-admin-form-panel">
          <div className="av-admin-form-container">
            <h2 className="av-admin-form-title">Admin Login</h2>
            <p className="av-admin-form-subtitle">
              Enter your email and password to continue
            </p>

            <form onSubmit={handleSubmit} className="av-admin-login-form">
             {(error || localError) && (
  <div className="av-admin-error-alert">
    <span className="av-admin-error-icon"><ShieldAlert/></span>
    <p className="av-admin-error-text">
      {error || localError}
    </p>
  </div>
)}
              {isAuthenticated && (
                <Alert className="av-admin-success-alert">
                  <AlertDescription className="av-admin-success-text">
                    Login successful! Redirecting...
                  </AlertDescription>
                </Alert>
              )}

              {/* Email Field */}
              <div className="av-admin-field-group">
                <label className="av-admin-field-label">
                  Email
                </label>
                <div className="av-admin-input-wrapper">
                  <div className="av-admin-input-icon">
                    <Mail className="av-admin-icon" />
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="admin@gmail.com"
                    className="av-admin-form-input"
                    disabled={loading}
                  />
                </div>
              </div>

              {/* Password Field - FIXED: Only one toggle button */}
              <div className="av-admin-field-group">
                <label className="av-admin-field-label">
                  Password
                </label>
                <div className="av-admin-input-wrapper">
                  <div className="av-admin-input-icon">
                    <Lock className="av-admin-icon" />
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="password"
                    className="av-admin-form-input av-admin-password-input"
                    disabled={loading}
                  />
                  {/* Single toggle button with explicit styling */}
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="av-admin-password-toggle"
                    disabled={loading}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {showPassword ? (
                      <EyeOff className="av-admin-toggle-icon" style={{ width: '18px', height: '18px' }} />
                    ) : (
                      <Eye className="av-admin-toggle-icon" style={{ width: '18px', height: '18px' }} />
                    )}
                  </button>
                </div>
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                disabled={loading}
                className="av-admin-submit-btn"
              >
                {loading ? (
                  <span className="av-admin-btn-loading">
                    <Loader2 className="av-admin-spinner" />
                    Signing In...
                  </span>
                ) : (
                  <span className="av-admin-btn-text">Sign In</span>
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}